<div class="field">
  {#if showLabel }
    <label class="label">Pick a suburb in the Hawkesbury-Nepean Valley</label>
  {/if}
  <div class="control has-icons-right {combo ? "combo" : ""}">
    <input
      class="input"
      type="text"
      placeholder={placeholder}
      bind:value={searchString}
      disabled={isSearchDisabled}
      class:has-value={hasValue} 
      on:keyup
      on:focus
      on:focusout|preventDefault
    />
    {#if (searchString && searchString.length > 0)}
      <span 
        class="icon is-small is-right close" 
        on:click|stopPropagation|preventDefault={clearSearch}>
        <img src={closeButtonIcon} alt="Close Button Icon" />
      </span>
    {:else}
      <span class="icon is-small is-right">
        <img src={searchIcon} alt="Search Icon" />
      </span>
    {/if}
  </div>
</div>

<script>
import { createEventDispatcher } from "svelte/internal";
//@ts-ignore
import SearchIcon from "../../../assets/images/Search_Icon.png";
//@ts-ignore
import CloseButtonIcon from "../../../assets/images/Close_Button_Icon.png";
import storage from "../../../services/StorageService";
export let isSearchDisabled = false;
export let hasValue = false;
export let showLabel = false;
export let placeholder = "";
export let searchString = "";
export let combo = false;
let closeButtonIcon = CloseButtonIcon;
let searchIcon = SearchIcon;
const dispatch = createEventDispatcher();
const clearSearch = () => {
    searchString = "";
    storage.setItem("ses-suburb", "");
    dispatch("clear");
};
</script>


<style>.field{margin-bottom:0}.field .label{font-weight:700;font-size:.875rem}.field .control .input{height:2.875rem;border-color:#f08403;border-radius:.625rem;font-size:.875rem;padding:14px 32px 14px 15px;color:#363636;line-height:19px;font-family:AvenirLT-Light,Helvetica,sans-serif;text-overflow:ellipsis}.field .control .input::-webkit-input-placeholder{font-size:.875rem;text-overflow:ellipsis}.field .control .input::-moz-placeholder{font-size:.875rem;text-overflow:ellipsis}.field .control .input:-ms-input-placeholder{font-size:.875rem;text-overflow:ellipsis}.field .control .input::-ms-input-placeholder{font-size:.875rem;text-overflow:ellipsis}.field .control .input::placeholder{font-size:.875rem;text-overflow:ellipsis}.field .control .input::-webkit-input-placeholder{font-size:.875rem;text-overflow:ellipsis}.field .control .input::-moz-placeholder{font-size:.875rem;text-overflow:ellipsis}.field .control .input:-ms-input-placeholder{font-size:.875rem;text-overflow:ellipsis}.field .control .input:-moz-placeholder{font-size:.875rem;text-overflow:ellipsis}.field .control .input:active,.field .control .input:focus{outline:none;box-shadow:none}.field .control .input.has-value{border-radius:.625rem .625rem 0 0;border-bottom-color:transparent}.field .control .icon{color:#f08403!important;right:8px;top:6px}.field .control .icon.close{cursor:pointer;pointer-events:auto;color:#9e9e9e!important}.field .control.combo .input{border:none;border-radius:0;height:34px;box-shadow:none;outline:none;border-top-left-radius:10px;border-bottom-left-radius:10px;font-size:14px}.field .control.combo .icon{height:22.63px;width:22.63px;right:4.62px;top:7px}@media screen and (max-width:767px){.field .control .input{font-size:1rem!important}}</style>
